<template>
    <div>
        <AjaxTable ref="AjaxTable" v-bind="this.$attrs" v-on="this.$listeners">
            <template #cell(clientName)="row">
                {{ row.item.reservation.client.firstName }}
                {{ row.item.reservation.client.lastName }}
            </template>
            <template #cell(clientPhone)="row">
                {{ row.item.reservation.client.phone }}
            </template>
            <template #cell(clientEmail)="row">
                {{ row.item.reservation.client.email }}
            </template>
            <template #cell(reservationId)="row">
                {{ row.item.serviceNumber }}
            </template>
            <template #cell(pickupDatetime)="row">
                {{ dateFormat(row.item.pickupDatetime) }}
            </template>
            <template #cell(flightDatetime)="row">
                <span
                    v-if="
                        flightStatusChange(row.item) &&
                        row.item.status == 'active'
                    "
                >
                    <md-icon icon="flight" variant="success" />
                    <b-spinner variant="warning" small type="grow" />
                </span>
                <span v-if="row.item.flightDatetime">
                    {{ timeFormat(row.item.flightDatetime) }} /
                    {{ row.item.flightNumber }}
                </span>
            </template>
            <template #cell(pickup)="row">
                {{ row.item.pickup.name }}
            </template>
            <template #cell(dropoff)="row">
                {{ row.item.dropoff.name }}
            </template>
            <template #cell(serviceType)="row">
                {{ row.item.serviceType.name }}
            </template>
            <template #cell(trackingStatus)="row">
                {{ trackingStatusLabels[row.item.trackingStatus] }}
            </template>
            <template #cell(transportUnit)="row">
                <span
                    v-if="
                        row.item.transportUnit !== null &&
                        row.item.transportUnit
                    "
                >
                    {{ row.item.transportUnit.title }}
                </span>
                <span v-else>N/A</span>
            </template>
            <template #cell(userDriver)="row">
                <span
                    v-if="
                        row.item.driver !== null &&
                        row.item.driver !== undefined
                    "
                >
                    {{ row.item.driver.firstName }}
                    {{ row.item.driver.lastName }}
                </span>
                <span v-else>N/A</span>
            </template>
            <template #cell(salesChannel)="row">
                {{ row.item.salesChannel.name }}
            </template>
			<template #cell(status)="row">
				<b-badge :variant="statusLabels[row.item.status].class">
					{{ statusLabels[row.item.status].text }}
				</b-badge>
            </template>
            <template #cell(passengers)="row">
                {{ $t("bookings.adults") }}: {{ row.item.reservation.adults
                }}<br />
                {{ $t("bookings.kids") }}: {{ row.item.reservation.children
                }}<br />
                {{ $t("bookings.infants") }}: {{ row.item.reservation.infants }}
            </template>
            <template #cell(supplierName)="row">
                <b-badge
                    :variant="
                        iconSupplierConfirmation(row.item.supplierConfirmation)
                            .class
                    "
                >
                    <md-icon
                        :icon="
                            iconSupplierConfirmation(
                                row.item.supplierConfirmation
                            ).icon
                        "
                    />
                </b-badge>
                {{ row.item.supplier.name }}
            </template>
            <template #cell(actions)="row">
                <div class="d-flex justify-content-center">
                    <b-button
                        class="mr-1"
                        size="sm"
                        v-if="$hasPermission('realtime.tracking.changeStatus')"
                        v-b-tooltip.hover
                        variant="outline-success"
                        style="float: right"
                        @click="showTrankingStatusService(row.item)"
                        content="Tracking"
                        v-tippy="{ arrow: true, arrowType: 'round' }"
                    >
                        <md-icon icon="emoji_transportation"></md-icon>
                    </b-button>
                    <b-button
                        @click="(event) => resView(row.item, row.index, event)"
                        type="button"
                        size="sm"
                        class="mr-1"
                        variant="info"
                        content="Service Detail"
                        v-tippy="{ arrow: true, arrowType: 'round' }"
                    >
                        <md-icon icon="visibility"></md-icon>
                    </b-button>
                </div>
            </template>
        </AjaxTable>
        <b-modal
            hide-footer
            ref="refTrackingStatus"
            size="sm"
            :title="`Tracking del servicio`"
        >
            <TrackingStatusService
                :itemService="itemService"
                @closeModal="
                    () => {
                        $refs['refTrackingStatus'].hide();
                    }
                "
            />
        </b-modal>
    </div>
</template>

<script>
// @ is an alias to /src
import AjaxTable from "@/components/helpers/AjaxTable.vue";
import TrackingStatusService from "./components/TrackingStatusService.vue";
import moment from "moment";
export default {
    components: {
        AjaxTable,
        TrackingStatusService,
    },
    props: {
        resView: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            itemService: {},
        };
    },
    methods: {
        showTrankingStatusService(item) {
            //recuperamos el registro del servicio
            this.itemService = item;
            //abrimos el modal de cambio de estado
            this.$refs["refTrackingStatus"].show();
        },
        iconSupplierConfirmation(status) {
            let icon = "";
            let classe = "";
            switch (status) {
                case "pending":
                    icon = "warning";
                    classe = "warning";
                    break;
                case "confirmed":
                    icon = "check_circle";
                    classe = "success";
                    break;
                case "rejected":
                    icon = "dangerous";
                    classe = "danger";
                    break;
            }
            return { icon: icon, class: classe };
        },
        getChildtableRef() {
            return this.$refs.AjaxTable;
        },
        dateFormat(val) {
            return moment(val).format("D MMM YYYY HH:mm");
        },
        timeFormat(val) {
            return moment(val).format("HH:mm");
        },
        flightStatusChange(item) {
            var flightDatetime = moment(item.flightDatetime);
            var actualFlightDatetime = moment(item.actualFlightDatetime);

            var minutes = moment
                .duration(actualFlightDatetime.diff(flightDatetime))
                .asMinutes();
            if (minutes < 0) {
                minutes = minutes * -1;
            }

            if (
                item.flightValidationStatus == "api" &&
                item.actualFlightDatetime != null &&
                minutes >= 30
            ) {
                return true;
            }

            return false;
        },
    },
    computed: {
		statusLabels() {
			let vars = this.$root.auxVars.transportServiceStatusOpts;
			let opts = {};
			for (let i = 0; i < vars.length; i++) {
				opts[vars[i].value] = vars[i];
			}
			return opts;
		},
        trackingStatusLabels() {
            let vars = this.$root.auxVars.transportServiceTrackingStatusOpts;
            let opts = {};
            for (let i = 0; i < vars.length; i++) {
                opts[vars[i].value] = this.$t(
                    `bookings.trackingStatusOpts.${vars[i].value}`
                );
            }
            return opts;
        },
    },
};
</script>
